import { render, staticRenderFns } from "./DynamicTable.vue?vue&type=template&id=323be606&scoped=true&"
import script from "./DynamicTable.vue?vue&type=script&lang=js&"
export * from "./DynamicTable.vue?vue&type=script&lang=js&"
import style0 from "./DynamicTable.vue?vue&type=style&index=0&id=323be606&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "323be606",
  null
  
)

export default component.exports